@if (versionUpdateService.updateAvailable()) {
  <div class="flex items-center justify-between h-[97px] gap-4 border-b border-amber-200 bg-amber-50 px-6 py-4 text-amber-950 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-100">
    <div class="text-sm font-medium">
      {{ 'versionUpdate.message' | translate }}
    </div>
    <button appButton type="secondary" (click)="refreshPage()">
      {{ 'versionUpdate.refresh' | translate }}
    </button>
  </div>
}
